import { BRAND } from "@/lib/brand";

export const WhatsAppFloat = () => {
  return (
    <a
      href={BRAND.whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_12px_30px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform duration-300"
    >
      <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true">
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.65-.515 2.65-1.49 0-.13-.013-.265-.043-.395-.122-.502-1.49-.94-1.49-1.124zM16.42 4.5c-6.345 0-11.5 5.155-11.5 11.5 0 2.117.575 4.187 1.677 6.005l-1.835 5.45 5.638-1.793A11.46 11.46 0 0 0 16.42 27.5c6.345 0 11.5-5.155 11.5-11.5s-5.155-11.5-11.5-11.5zm6.683 18.184a9.49 9.49 0 0 1-6.683 2.762 9.43 9.43 0 0 1-4.81-1.317l-.345-.205-3.567 1.137 1.135-3.485-.225-.36a9.46 9.46 0 0 1-1.46-5.066c0-5.244 4.272-9.516 9.516-9.516 5.243 0 9.515 4.272 9.515 9.516a9.44 9.44 0 0 1-2.776 6.734z" />
      </svg>
    </a>
  );
};
